import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { IUserState }           from 'Redux/Slices/User/UserSlice';
import User                     from 'Domain/Models/User/User';

export const logout = (state: Draft<IUserState>, { type }: PayloadAction) => {
  state.updatedAt = Date.now();
};
